export const COLORS_CORPORATE_RISK = [
  '#00B050',
  '#00CC00',
  '#92D050',
  '#FFE699',
  '#FFC000',
  '#ED7D31',
  '#FF0000',
  '#C00000',
  '#9c9c9c',
]

export const COLORS_PERFORMANCE = [
  '#87D4A4',
  '#C3D785',
  '#FFDE86',
  '#EB6671',
  '#9c9c9c',
]
